<template>
  <div>
    <p>
      <b>TOTAL : {{ totalList }}</b>
    </p>
  </div>
</template>

<script>
export default {
  name: 'totalList',
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      totalList: 0
    }
  },
  watch: {
    value: function(value) {
      this.totalList = value.total
    }
  }
}
</script>
